import MenuBookIcon from "@mui/icons-material/MenuBook";

// Central icon for courses. Replace here to update everywhere.
export default MenuBookIcon;
